/* eslint-disable react/no-unknown-property */
import { ConcurrencyError } from '@rhybus/api'
import React from 'react'
import { Link } from 'react-router-dom'

import { sitePath } from '../../assets/ts/api/api'
import { mpfRListsHttp } from '../../assets/ts/api/mpf-r-lists-http'
import { formatUTCDateToLocal } from '../../assets/ts/date-and-time/date-and-time'
import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'

interface Props {
  handleNotifications: any
  me: any
  notifications: any[]
  setMultiplePopup: any
}

const NotificationTabContent = ({
  handleNotifications,
  me,
  notifications,
  setMultiplePopup,
}: Props) => {
  const handleClick = async (data, url, e) => {
    const menuToHighlight = data?.IsDueOut ? '/dueouts' : '/inquiries'

    sessionStorage.setItem('menuToHighlight', menuToHighlight)
    e.preventDefault()

    try {
      const filteredNotifications = notifications.filter((noti) => noti.DataGUID === data.DataGUID)
      if (filteredNotifications.length > 0) {
        const list = await mpfRListsHttp().getList('NotificationsList')

        const promiseArr: any[] = []
        filteredNotifications.forEach((notification) => {
          const newReadArray = notification.ReadArray || []
          if (!newReadArray.includes(me.userId)) {
            newReadArray.push(me.userId)

            promiseArr.push(
              list.addOrUpdateItem({
                ...notification,
                ReadArray: newReadArray,
              })
            )
          }
        })

        await Promise.all(promiseArr)
      }

      if (window.location.href !== url) window.location.href = url
    } catch (err) {
      if (err instanceof ConcurrencyError) {
        console.error(`${err}`)
      } else {
        console.error(err)
      }
    }
    handleNotifications()
    setMultiplePopup()
  }

  return (
    <ul>
      {notifications?.length > 0 ? (
        notifications.map((item: any, index: number) => {
          const url = `${sitePath}/${item.IsDueOut ? 'dueoutdetailview' : 'detailview'}/${
            item.DataGUID
          }`

          return (
            <li
              aria-describedby={item.id}
              className={item.IsRead ? '' : 'bold'}
              id={item.id}
              key={index}
              notification-code={item.AlertType === 'NOTIFICATION' ? 2 : 1}
              tabIndex={0}
            >
              <div className='title-color33 poppins-medium  font-12 lh-normal'>
                <span>{item.AlertText.split(item.DataID)[0]}</span>
                <Link
                  className={`links color-primary ${item.IsRead ? '' : 'font-14'}`}
                  onClick={(e) => handleClick(item, url, e)}
                  title={item.DataID}
                  to='#'
                >
                  {defaultToEmptyString(item.DataID)}
                </Link>
                <span> {defaultToEmptyString(item.AlertText.split(item.DataID)[1])}</span>
              </div>
              <div className='title-color34 sourcesanspro font-12'>
                {defaultToEmptyString(formatUTCDateToLocal(item.ItemCreated))}
              </div>
            </li>
          )
        })
      ) : (
        <div
          aria-label=' There are no results to display'
          className='noresults subtitle-color2 sourcesansprosemibold font13 text-center py-2'
          tabIndex={0}
        >
          There are no results to display
        </div>
      )}
    </ul>
  )
}
export default NotificationTabContent
